import React from 'react';
import TituloTexto from '../../../layout/titulo-texto';

const PagoPendiente = () => {
  const texto = 'En las próximas 24 hs estarás recibiendo un email con los datos de tu reserva junto a los comprobantes';
  return (
    <TituloTexto titulo='Tu pago se encuentra pendiente' texto={texto} />
  );
};

export default PagoPendiente;
